import { Button, Tooltip, useNavigation } from '@eleveo/components-react';
import { AppSwitchIcon, UserIcon } from '@eleveo/icons-react';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSwitcherAppsQuery } from '../../../api/keycloakQuery';
import { useAuth } from '../../../app/AuthorizationProvider';
import { useConfig } from '../../../app/ConfigurationProvider';
import { TEST_IDS } from '../../../constants/dataTestIds';
import { getAppSwitcherLinks, getUserManagementLinks } from '../../../router/navItems';
import { OverlayTrigger } from '../../overlay/OverlayTrigger';
import { AppSwitcher } from '../appswitcher/AppSwitcher';
import { ManageAccountDropdown } from '../manageAccount/ManageAccountDropdown';

export const DrawerSideBoxFooter: React.FC = () => {
  const { isOpen } = useNavigation();
  const { t } = useTranslation();
  const config = useConfig();
  const auth = useAuth();
  const appSwitcherApps = useAppSwitcherAppsQuery();

  const appSwitcherLinks = getAppSwitcherLinks(config, appSwitcherApps.data, t);
  const userManagementLinks = getUserManagementLinks(auth, config, t);
  const { userName } = auth;

  return (
    <div
      className={clsx('drawer-footer', 'flex', 'items-center', {
        'drawer-footer--collapsed': !isOpen,
      })}
    >
      <div className="drawer-footer__button-wrapper flex-shrink-0">
        <OverlayTrigger
          crossOffset={15}
          offset={16}
          placement="top left"
          className="user-management-overlay"
          triggerElement={
            <Button
              isSmall
              className="drawer-footer__user-management rounded-full"
              testId={TEST_IDS.buttonUserManagement}
              aria-label={t('applications.userManagement')}
            >
              <UserIcon />
            </Button>
          }
        >
          <ManageAccountDropdown userName={userName} links={userManagementLinks} />
        </OverlayTrigger>
      </div>

      <Tooltip content={userName}>
        <span className="flex-grow drawer-footer__user-name leading-none font-medium truncate" aria-hidden={!isOpen}>
          {userName}
        </span>
      </Tooltip>

      <div className="drawer-footer__button-wrapper flex-shrink-0">
        <OverlayTrigger
          crossOffset={15}
          offset={16}
          title={t('layout.navigation.switchApplications')}
          placement="top left"
          className="app-switcher-overlay"
          triggerElement={
            <Button
              isSmall
              className="drawer-footer__app-switcher"
              testId={TEST_IDS.buttonAppSwitcher}
              aria-label={t('layout.navigation.applicationSwitcher')}
            >
              <AppSwitchIcon />
            </Button>
          }
        >
          <AppSwitcher links={appSwitcherLinks} />
        </OverlayTrigger>
      </div>
    </div>
  );
};
